module.exports = __webpack_public_path__ + "static/media/coffin_icon.6d132d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/coffin_icon.png
// module id = 562
// module chunks = 0